import { render, staticRenderFns } from "./FormOrder.vue?vue&type=template&id=3ba6a054&"
import script from "./FormOrder.vue?vue&type=script&lang=js&"
export * from "./FormOrder.vue?vue&type=script&lang=js&"
import style0 from "./FormOrder.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports